export const ChatsView = () => {
  return <div className="p-2">Chats View</div>
}
